export default __webpack_public_path__ + "static/media/footer-naver.49b58292.png";